module.exports = __webpack_public_path__ + "assets/fdd2276245aa868ab74fb8fa9b45b96e.mp3";